import { httpClientCustomer } from '../http-client-customer'

interface CancellationReceipt {
  saleId?: string
  merchantIds?: string
}

export async function cancellationReceipt({ saleId, merchantIds }: CancellationReceipt) {
  return await httpClientCustomer<Blob>({
    url: `/affiliations/${merchantIds}/transactions/${saleId}/cancellation-receipt`,
    method: 'GET',
    responseType: 'blob'
  })
}
